import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

export const StyledSvgIcon = styled(IconButton, {
  shouldForwardProp: (props) => props !== 'isSquare'
})(({ isSquare }) => ({
  ...(isSquare && {
    borderRadius: '4px'
  })
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpIconButton/styles.js